import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { constants } from "@qgiv/core-js";
import {
    selectPayPal,
    selectShouldDisplayApplePay,
} from "../../../redux/slices/appSettingsSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import DigitalWalletPaymentOptions from "./DigitalWalletPaymentOptions";

const ConnectedDigitalWalletPaymentOptions = ({ controlId }) => {
    const {
        ENUMS: { PaymentType },
    } = constants;
    const shouldDisplayApplePay = useSelector(selectShouldDisplayApplePay);
    const payPal = useSelector(selectPayPal);
    const { hasInitiatedPayPalAuthorizationFlow = false } = payPal;

    const formik = useFormikContext();
    const {
        values: { Payment_Type = 0 },
    } = formik;

    const formSettings = useSelector(selectAllFormSettings);
    const {
        enableAchPayments = false,
        enableCCPayments = false,
        enablePaypalPayments = false,
    } = formSettings;

    // The Apple Pay button is displayed if the org & form are set up for it,
    // the form is viewed on a supported device and PayPal is not selected. The
    // Apple Pay button is also hidden if the user has initiated a PayPal
    // request
    const displayApplePayPaymentMethod =
        shouldDisplayApplePay && Payment_Type !== PaymentType.PAYPAL;
    // Hide the PayPal UI once the user clicks on the Apple Pay button
    const displayPaymentPayPal =
        enablePaypalPayments && Payment_Type !== PaymentType.APPLEPAY;
    // Display the or text once either the Bank or the CC payment method is
    // visible until the user clicks on the Apple Pay button
    const displayOrText =
        (enableAchPayments || enableCCPayments) &&
        Payment_Type !== PaymentType.APPLEPAY;
    // Display the user a different payment method button once the user has
    // clicked on the Apple Pay or the PayPal button
    const displayUseADifferentPaymentMethodButton =
        (hasInitiatedPayPalAuthorizationFlow &&
            Payment_Type === PaymentType.PAYPAL) ||
        Payment_Type === PaymentType.APPLEPAY;
    // Consolidate payment data into an object so that it available within the
    // mapDispatchToProps() function that is run inside of
    // ConnectedPaymentPaypal as we need it in order to reset the Payment_Type
    // a robust manner that would still work if donor accounts are ever added
    // to the redesigned P2P registration
    const paymentData = {
        enableAchPayments,
        enableCCPayments,
        enablePaypalPayments,
    };

    const digitalWalletPaymentOptionsProps = {
        controlId,
        displayApplePayPaymentMethod,
        displayOrText,
        displayPaymentPayPal,
        displayUseADifferentPaymentMethodButton,
        formik,
        paymentData,
    };

    return (
        <DigitalWalletPaymentOptions {...digitalWalletPaymentOptionsProps} />
    );
};

ConnectedDigitalWalletPaymentOptions.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedDigitalWalletPaymentOptions;
